<template>
  <div>
    <div @click="escapeDialog" :class="{ 'custom-dialog': true, 'is-visible': isVisible, [cssClass]: true }" id="dialog-box" />
    <div :class="{ 'dialog-box': true, 'is-visible': isVisible, [type]: true, [size]: true, [cssClass]: true }" ref="container" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'custom-dialog',
  props: {
    canEscape: {
      default: true,
      type: Boolean,
    },
    slotComponent: Function,
    propsData: Object,
    type: {
      type: String,
      default: 'normal',
    },
    size: {
      type: String,
      validator: (value: string) => value === 'large' || value === 'medium',
      default: 'medium',
    },
    cssClass: {
      type: String,
      default: '',
    },
  },
})
export default class CustomDialog extends Vue {
  protected isVisible = false;
  protected canEscape?: boolean;
  protected slotComponent!: object;
  protected hasMounted!: boolean;
  protected propsData!: object;

  protected showDialog() {
    setTimeout(() => (this.isVisible = true), 100);
  }

  protected closeDialog() {
    this.isVisible = false;
    setTimeout(() => this.$emit('close-dialog'), 300);
  }

  protected escapeDialog() {
    if (this.canEscape) {
      this.closeDialog();
    }
  }

  protected beforeDestroy() {
    window.removeEventListener('keyup', this.handleKeyUp);
  }

  protected handleKeyUp(e: KeyboardEvent) {
    if (e.keyCode === 27 && this.canEscape) {
      this.closeDialog();
    }
  }

  protected mountComponent() {
    if (!this.hasMounted) {
      window.addEventListener('keyup', this.handleKeyUp);
      const SlotComponentClass = Vue.extend(this.slotComponent);
      const slotComponent = new SlotComponentClass({
        propsData: {
          closeDialog: this.closeDialog,
          ...this.propsData,
        },
        data() {
          return {};
        },
      });
      slotComponent.$mount();
      (this.$refs.container as any).appendChild(slotComponent.$el);
      this.showDialog();
      this.hasMounted = true;

      slotComponent.$on('close-dialog', () => this.closeDialog());
    }
  }

  protected mounted() {
    window.scrollTo(0, 0);
    this.mountComponent();
  }
}
</script>

<style src="./custom-dialog.component.scss" lang="scss"></style>
